import { createContext, useContext, useMemo } from "react";

import { buildStatusCatalogue, type StatusCatalogue } from "./statusCatalogue";

export interface StatusCatalogueValue {
  catalogue: StatusCatalogue;
  /** The building the catalogue was loaded for; undefined outside a building. */
  buildingId: number | undefined;
  isLoading: boolean;
}

export const StatusCatalogueContext = createContext<StatusCatalogueValue | null>(null);

/**
 * The catalogue in scope. Outside a provider this is the three built-ins —
 * the behaviour the app had before custom statuses — so a component rendered
 * in isolation (a test, a preview) still draws a real badge rather than
 * throwing.
 */
export function useStatusCatalogue(): StatusCatalogueValue {
  const ctx = useContext(StatusCatalogueContext);
  const fallback = useMemo(
    () => ({
      catalogue: buildStatusCatalogue([], "en"),
      buildingId: undefined,
      isLoading: false,
    }),
    []
  );
  return ctx ?? fallback;
}
